module.exports = __webpack_public_path__ + "media/son.03492eab.mp3";